import { styled } from "styled-components";
import ProgressBar from "src/components/ProgressBar"
import NavigationController from "./NavigationController";
import { theme } from "src/styles/theme";
import MultipleVideoPlayer from "src/components/MultipleVideoPlayer";
import CircularProgress from "src/components/CircularProgress";
import VideoPlayer from "src/components/VideoPlayer";
import { useMediaQuery } from "react-responsive";
import { useEffect, useState } from "react";
import { useBoundStore } from "src/store";

const RespondButton = styled.button`
    height: 43px;
    background-color: ${theme.colors.respondButton};
    color: ${theme.colors.white};
    font-family: ${theme.fonts.primary};
    font-weight: ${theme.fontWeights.semiBold};
    font-size: ${theme.fontSizes.base};
    padding: 12px 20px;
    border-radius: ${theme.borderRadius.pill};
    border: none;
    cursor: pointer;
    transition: all 0.2s ease;
    box-shadow: ${theme.shadows.buttonShadow};

    &:hover {
        transform: translateY(-2px);
        box-shadow: ${theme.shadows.medium};
    }
`;
const Container = styled.div`
    width: 100%;
    height: 100%;

    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    // gap: 25px;
`;
const SkipButton = styled.button`
   
`;
interface QCastProps {

}
const Content = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 15px;
  flex: 1;
`;

const PlayerHost = styled.div<{ size?: string }>`
  //width: ${props => props.size || '520px'};
  height: ${props => props.size || '520px'};
`;

const UserProfileAvatar = styled.div<{ ismobile?: boolean }>`
  width: 40%;
  height: 40%;
  border-radius: 50%;
  margin-bottom: 40px;
  box-shadow: 0px 30px 100px -20px #00000033;
  background: #39393A;  
  position:relative;
  margin-left:auto;
bottom: 40%;
  z-index: 99999999999999999999;
  clip-path: circle(50% at center); 

  &>svg{
    width: 100%;
    height: 100%;
    margin-top: 20px;
  }

  @media(max-width: ${theme.breakpoints.mobile}px) {
    left: 190px;
  }
`;
const VideoArea = styled.div`
    width: 100%;
    height: auto;

    flex: 1;
    display: flex;
    flex-direction: row;
    align-items: start;
    justify-content: space-between;
    padding: 0px 40px;

    z-index: 999999999;

    @media(max-width: ${theme.breakpoints.mobile}px) {
      padding-top: 40px;
      flex-direction: column;
      align-items: center;
      justify-content: center;
    }
`;


const QCastContent: React.FC<QCastProps> = ({ }) => {
    const { responseVideo, questions, } = useBoundStore();

    const isMobileScreen = useMediaQuery({ query: `(max-width: 460px)` });
    const [controllerPlay, setControllerPlay] = useState<boolean>(false);
    const [activeVideo, setActiveVideo] = useState<"main" | "multi" | null>(null);
    const [progress, setProgress] = useState<number>(0);
    const [progress2, setProgress2] = useState<number>(0);
    const [totalProgress, setTotalProgress] = useState<number>(0);
    const [totalProgress2, setTotalProgress2] = useState<number>(0);
    const [totalDuration, setTotalDuration] = useState<number>(0);
    const [playing, setPlaying] = useState(false);
    const [playing2, setPlaying2] = useState(false);
    const [currentIndex, setCurrentIndex] = useState<number>(0);
    const [allquestions, setAllquestions] = useState<any[]>([]);
    const [videoList, setVideoList] = useState<any[]>([])
    const [muteVideo, setMuteVideo] = useState(false);
    const [seekVideo, setSeekVideo] = useState<any>({status:false});
    const [multiVideos, setMultiVideos] = useState<any[]>([]);



    const handleChangeQcast = (index: number) => {
        setProgress(0)
        setActiveVideo("main")
        if (index === -1 && currentIndex === 0) return;
        if (index === 1 && currentIndex === responseVideo.length - 1) return;
        handleNextVideo(currentIndex + index)
    }
    const onVideoCompleted = () => {
        /* const allVideo=[...videoList]
        allVideo[videoList.length-1]["status"]="PLAYED"
        allVideo[videoList.length-1]["progress"]=0
        setVideoList(allVideo) */
        setControllerPlay(false)
        setActiveVideo("main")
        setPlaying2(false)
        setPlaying(false)
    }
    const updateDuration = (duration: number, index: number) => {
/*   const previousList = [...allquestions]

    previousList[index]["questionDuration"] = duration
    setAllquestions(
      previousList
    ); */
    }
    const handleVideoEnded = () => {
        setActiveVideo("main")
        if (currentIndex === responseVideo.length - 1) {
            return;
        }
        setCurrentIndex((prev) => prev + 1);
    }

    const handlePlay = (status: boolean) => {
        setControllerPlay(status)
        if (activeVideo == "main") {
            setPlaying(status)
            if(status){
                setPlaying2(status)
            }
            return
        }
        if (activeVideo == "multi") {
            setPlaying2(status)
            return
        }
        setActiveVideo("main")
        setPlaying(status)
        setPlaying(status)

    }

    const handleProgress = (prog: number) => {
        setProgress(prog);
    }

    const handleNextVideo = (index: number) => {

        setCurrentIndex(index);
        setActiveVideo("main")
        setPlaying(true)
    }
    const handleMuteVideo = (status: boolean) => {
        setMuteVideo(status);
    }
    const handleSelectVideo = (index: number) => {
        setCurrentIndex(index);
    };
     /*  useEffect(() => {
        const prog2 = progress2 / (100 / allquestions[currentIndex]?.questionDuration || 0.01)
        const vidDur = responseVideo[currentIndex]?.duration || 0.01
        const quesDur = allquestions[currentIndex]?.questionDuration || 0.01
        const factor = 100 / (vidDur + quesDur)
        let ownProgress=progress
        if(activeVideo=="main"&&(playing || playing2)){
          ownProgress=0
        }
        setTotalProgress((prog2 + ownProgress) * factor)
        setTotalProgress2((prog2 + ownProgress))
      }, [progress, progress2]); */
    useEffect(() => {
        if (responseVideo.length > 0 && questions?.listOfVideos.length>0) {
            setCurrentIndex(0)
            console.log("responseVideo",responseVideo)
             const resData=responseVideo.map((video) => (
                    {
                        url: video.answer,
                        title: "",
                        index:questions.listOfVideos.indexOf(video.question),
                        duration:video.totalResponseDuration,
                        questionDuration:video.totalQuestionDuration
                    }
                ))
            setMultiVideos(
               resData
            )
            let totalRes=0
            resData.forEach((v)=>{
                totalRes=+v.duration
            })
            setTotalDuration(totalRes)

        }
    }, [responseVideo,questions?.listOfVideos]);
const skipQuestion=()=>{
    if (activeVideo=="multi") return;
setActiveVideo("multi"); setPlaying2(true)
let seekTo=0
try {
    seekTo=multiVideos[currentIndex].questionDuration/1000
} catch (error) {
    
}
setSeekVideo({status:true,to:seekTo})

}
const formatTime=(seconds: number)=> {
    if(seconds<0) return "00:00"
    try {
         const mins = Math.floor(seconds / 60);
    const secs = parseInt(`${seconds % 60}`);
    // Pad seconds with leading zero if needed
    const paddedSecs = secs.toString().padStart(2, '0');
    return `${mins.toString().padStart(2, '0')}:${paddedSecs}`;
}
     catch (error) {
       return "00:00" 
    }
}
    return (
        <Container>
            <VideoArea >
                <Content style={{ width: "100%", padding: "0px 40px", height: "100%" }}>
                    <PlayerHost size={isMobileScreen ? `280px` : `100%`}>
                        <CircularProgress
                            size={270}
                            strokeWidth={7}
                            progress={totalProgress}
                            progressColor="#8451D6"
                            trailColor="#ddd"
                            startAngle={270}
                            onFinish={() => alert("Progress Completed!")}
                        >
                            <MultipleVideoPlayer
                                videos={multiVideos}
                                overidePlay={true}
                                currentIndex={currentIndex}
                                size={"320px"}
                                playing={activeVideo == "main" && playing||activeVideo == "multi" && playing2}
                                muteVideo={activeVideo == "main" && playing}
                                onVideoEnded={handleVideoEnded}
                                onVideoCompleted={() => { onVideoCompleted() }}
                                onProgress={handleProgress}
                                onDuration={() => { }}
                                onPause={handlePlay}
                                onSeek={() => { }}
                                onNextVideo={handleNextVideo}
                                seekVideo={seekVideo}
                                repeatVideoPlayback={false}
                                
                            />
                        </CircularProgress>

                        <UserProfileAvatar ismobile={isMobileScreen}>
                            <VideoPlayer
                                vidSrc={questions?.listOfVideos[multiVideos[currentIndex]?.index || 0] || ""}
                                hidePlayVideoIcon={true}
                                play={activeVideo == "main" && playing}
                                showProgress={false}
                                size={120}
                                playsize={48}
                                hideSeek={true}
                                onProgress={(e) => { setProgress2(e) }}
                                onDuration={(e) => { updateDuration(e, currentIndex) }}
                                onPause={() => { }}
                                onPlay={() => { }}
                                onReady={(e) => { }}
                                onVideoEnded={() => { setActiveVideo("multi"); setPlaying2(true) }}
                            />
                        </UserProfileAvatar>
                    </PlayerHost>
<p style={{color:"black"}}>{`${formatTime(progress)}/${formatTime((multiVideos[currentIndex]?.duration||0)/1000)}`}</p>
<NavigationController hideResponse={false} respondText={"Skip Question"} onNavigate={handleChangeQcast} onResponse={() => skipQuestion()} />
                    
                </Content>

            </VideoArea>
            <div style={{ width: "100%", padding: "0px 40px", zIndex: "999999999999999999" }}>
                <ProgressBar
                    currentIndex={currentIndex}
                    videos={multiVideos}
                    progress={totalProgress}
                    totalDuration={totalDuration}
                    onPlay={handlePlay}
                    playing={controllerPlay}
                    onRepeat={() => { }}
                    onSelectVideo={handleSelectVideo}
                    onMute={handleMuteVideo}
                    onShuffle={() => { }}
                    hideDuration={true}
                    hideRepeat={true}
                    hideShuffle={true}
                    hideQueueBtn={true}
                    barColor='#B7AAD6'
                />
            </div>
        </Container>
    )
}

export default QCastContent